'use client';

import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import { useLanguage } from '@/contexts/LanguageContext';

interface ProductHighlightProps {
  metal: string;
  weights: string[];
  purity: string;
  image: string;
  imageAlt: string;
}

const ProductHighlight = ({ metal, weights, purity, image, imageAlt }: ProductHighlightProps) => {
  const { t } = useLanguage();

  return (
    <div className="bg-card rounded-lg p-6 border border-border">
      {/* Product Image */}
      <div className="relative w-full h-48 mb-6 rounded-md overflow-hidden bg-muted">
        <AppImage
          src={image}
          alt={imageAlt}
          width={600}
          height={400}
          className="object-cover w-full h-full"
        />
      </div>

      <h3 className="font-heading text-xl font-semibold text-foreground mb-4">
        {metal}
      </h3>
      
      <div className="space-y-4">
        <div>
          <p className="caption text-muted-foreground mb-2">{t('products.availableWeights')}</p>
          <div className="flex flex-wrap gap-2">
            {weights.map((weight, index) => (
              <Link
                key={index}
                href="/price-list"
                className="data-text text-xs bg-muted px-3 py-1.5 rounded-md text-foreground hover:bg-gradient-gold hover:text-primary transition-luxury cursor-pointer"
              >
                {weight}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="caption text-muted-foreground mb-1">{t('products.purityLabel')}</p>
          <p className="data-text text-sm font-medium text-foreground mb-3">{purity}</p>
          <Link
            href="/price-list"
            className="inline-block bg-gradient-gold text-primary px-6 py-2 rounded-md hover:shadow-gold-glow transition-luxury font-medium text-sm"
          >
            {t('products.priceList')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductHighlight;